<template>
  <!-- Empty / error placeholder under a Backup restore table. -->
  <div class="bk-state" :class="{ 'bk-state--error': !!error }">
    <i :class="error ? 'fa-solid fa-plug-circle-exclamation' : (icon || 'fa-regular fa-folder-open')" class="bk-state__icon"></i>
    <div class="bk-state__title">{{ error ? $t('backup.loadError') : (title || $t('backup.empty')) }}</div>
    <div v-if="error" class="bk-state__hint">{{ error }}</div>
    <div v-else-if="hint" class="bk-state__hint">{{ hint }}</div>
    <b-button v-if="error" size="sm" variant="outline-primary" class="mt-1" @click="$emit('retry')">
      <i class="fa-solid fa-rotate-right mr-25"></i>{{ $t('backup.retry') }}
    </b-button>
  </div>
</template>

<script>
export default {
  name: 'BackupTableState',
  props: {
    error: { type: String, default: null },
    title: { type: String, default: null },
    hint: { type: String, default: null },
    icon: { type: String, default: null },
  },
}
</script>

<style scoped lang="scss">
.bk-state {
  text-align: center; padding: 2.6rem 1rem; color: #9a9dad;
  &__icon { font-size: 2.2rem; opacity: 0.45; }
  &__title { margin-top: 0.7rem; font-weight: 700; font-size: 0.98rem; color: #5e5873; }
  &__hint { margin-top: 0.2rem; font-size: 0.82rem; }
  &--error .bk-state__icon { color: #ea5455; opacity: 0.75; }
}
body.dark-layout .bk-state__title { color: #d0d2d6; }
</style>
